import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import SliderImage from "./SliderImage";
import AboutDetail from "./AboutDetail";
import OurStrength from "./OurStrength";
import LogoCollection from "./LogoCollection";
// import MoreButton from "./MoreButton";

export default function AboutUS() {
  return (
    <Box id="hero">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          // pt: { xs: 0, sm: 0 },
          // pb: { xs: 8, sm: 12 },
        }}
      >
        <SliderImage />
        <AboutDetail />

        <OurStrength />
        <LogoCollection />
        {/* <MoreButton/> */}
      </Box>
    </Box>
  );
}
